import { CoreIcon } from '../core-icon';
import infoCircleFillSVG from '../../../src/images/icons/info-circle-fill.svg';

export const InfoCircleFillIcon = props => {
  return <CoreIcon src={infoCircleFillSVG} {...props} />;
};
